import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSizePipe } from './file-size.pipe';
import { TruncatePipe } from './truncate.pipe';
import { NomeUsuarioPipe } from './nome-usuario.pipe';
import { NumeroAportePipe } from './numero-aporte.pipe';
import { NumeroConglomeradoPipe } from './numero-conglomerado.pipe';

@NgModule({
    declarations: [FileSizePipe, TruncatePipe, NomeUsuarioPipe, NumeroAportePipe, NumeroConglomeradoPipe],
    imports: [
        CommonModule
    ],
    exports: [
        FileSizePipe,
        TruncatePipe,
        NomeUsuarioPipe,
        NumeroAportePipe,
        NumeroConglomeradoPipe
    ],
    providers: [
        NumeroConglomeradoPipe
    ]
})
export class PipesModule { }
